import SVG from "react-inlinesvg";
import styled from "styled-components/macro";
import ProgressContainer from "../ProgressContainer";
import classNames from "classnames";
import { useAppStore } from "../../stores/appStore";

const SubmitButton = styled.div`
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px 8px 10px;
    height: 26px;
    border-radius: 10px;
    background-color: var(--primary-cta);
    color: var(--cta-text-color);
    font-weight: 500;
    gap: 5px;
    span {
      margin-right: 3px;
    }
    svg {
      path {
        fill: var(--cta-text-color);
      }
      border: 2px solid rgba(255, 255, 255, 0.4);
      border-radius: 3px;
    }
    cursor: pointer;
  }
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  &.loadingGoButton {
    cursor: wait;
    pointer-events: none;
  }
`;

function GoButton({ onClick, disabled, progressLoading = false, progressDuration = 60, className, labelOverride = null }) {
  const isMac = useAppStore((state) => state.isMac);

  return (
    <SubmitButton
      onClick={onClick}
      aria-label={`Press ${isMac ? "command" : "control"} plus enter to generate`}
      className={classNames({ disabled, loadingGoButton: progressLoading, [className]: className })}
    >
      <ProgressContainer
        isLoading={progressLoading}
        duration={progressDuration}
      >
        <span>{labelOverride || "Go"}</span>
        <SVG
          src={isMac ? "/assets/keyboard-shortcuts/command-key.svg" : "/assets/keyboard-shortcuts/control-key-pc.svg"}
          aria-hidden="true"
          height={19}
          width={21}
        />
        <SVG
          src="/assets/keyboard-shortcuts/enter-key.svg"
          aria-hidden="true"
          height={19}
          width={21}
        />
      </ProgressContainer>
    </SubmitButton>
  );
}

export default GoButton;
